module.exports = __webpack_public_path__ + "img/50fr.7e1d0536.png";